export const simpleFields = {
  buildingName: {
    header: 'Building name',
    width: 40,
    selected: false
  },
  uniqueCode: {
    header: 'Building unique code',
    width: 21,
    selected: false
  },
  customerInstallApprovalRequired: {
    header: 'Customer install approval required',
    width: 25,
    selected: false
  },
  inductionRequired: {
    header: 'Induction required',
    width: 21,
    selected: false
  },
  avgFloorHeight: {
    header: 'Avg floor height',
    width: 17,
    selected: false
  },
  numberOfLevels: {
    header: 'Number of levels',
    width: 12,
    selected: false
  },
  numberOfDwellings: {
    header: 'Number of dwellings',
    width: 17,
    selected: false
  },
  estimatedServiceDeliveryTime: {
    header: 'Estimated service delivery time',
    width: 30,
    selected: false
  },
  parkingAvailability: {
    header: 'Parking availability',
    width: 20,
    selected: false
  }
}
